import React, { useContext } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { petsPathTo } from '../utils/Api';
import SnackbarContext from '../contexts/SnackbarContext';
import { PetsContext } from '../contexts/PetsContext';

const NewPetDialog = ({ open, handleClose }) => {
  const { openSnackbar } = useContext(SnackbarContext);
  const { setPetsList } = useContext(PetsContext);
  const [newPet, setNewPet] = React.useState({
    name: '',
  })

  const handleSubmit = (event) => {
    event.preventDefault();
    petsPathTo.save({
      name: newPet.name,
    }).then((result) => {
      // return all pets
      setPetsList(result.data)
      openSnackbar("Pet adicionado com sucesso!", "success");
    });
    handleClose();
  }
  return (
    <Dialog open={open} onClose={handleClose}>
      <form onSubmit={handleSubmit}>
        <DialogTitle>Adicionar novo pet</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            value={newPet.name}
            onChange={(event) =>
              setNewPet({
                name: event.target.value,
              })
            }
            label="Nome"
            type="text"
            variant="standard"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button type="button" onClick={handleSubmit} variant="contained">Adicionar</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default NewPetDialog
